import revokeTokenHandler from '../../pattern_utilities/revokeTokenHandler';
import { tryToGetMyPatterns, tryToGetTeamPatterns } from '../actions.export.js'

var pf_config = require('../../pf_config.json');
var Cookies = require('js-cookie');

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// DELETE PATTERN
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestDeletePattern = data => ({
  type: 'REQUEST_DELETE_PATTERN',
  data
})

export const receiveDeletePatternSuccess = data => ({
  type: 'RECEIVE_DELETE_PATTERN_SUCCESS',
  data
})

export const receiveDeletePatternFail = data => ({
  type: 'RECEIVE_DELETE_PATTERN_FAIL',
  data
})

export const tryToDeletePattern = id => (dispatch, getState) => {
  dispatch(requestDeletePattern(id));

  const { team, user } = getState();

  if(window.confirm("Are you sure you want to delete this pattern?")){

    return fetch('/api/patterns/id/' + id, {
        method: 'delete',
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + Cookies.get(process.env.REACT_APP_COOKIE_AUTH)
        }
      })
      .then((response) => {
        let json = response.json();
        if (response.status >= 200 && response.status < 300) return json;
        return json.then(Promise.reject.bind(Promise));
      })
      .then(function(json){
        dispatch(receiveDeletePatternSuccess(json));
        if(team.current){
          dispatch(tryToGetTeamPatterns({
            id: team.current
          }));  
        } else {
          dispatch(tryToGetMyPatterns());
        }
      })
      .catch(e => {
        revokeTokenHandler(e);
        dispatch(receiveDeletePatternFail({errors:e, lastSubmit: id}));
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/pattern/a.p.DELETE.pattern.js